import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';

// Version 1.1.0 - Enhanced Prebid Build Configuration with Dynamic Module Discovery
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);